import { handleResponse } from '../Helpers/handle-response';
import * as apiHelper from '../Helpers/apiHelper';

export const dataService = {
    getProductionOrdersByMachine,
    getProductionOrdersBySearchText,
    getOrderDetailsByOrderId,
    saveVisitorRegistration,
    updateProductionOrderMetaData,
    assignQuantityAtMachine,
    getMachineInAssignedByMachineId,
    deleteMachineInAssignedById,
    startProductionOrder,
    pauseProductionOrder,
    stopProductionOrder,
    finishProductionOrder,
    getTransportOrdersHistory,
    getActiveTransportOrders,
    createNewBooking,
    getQualityChecksByOrderId,
    getOperators,
    getQualityCheckSteps,
    getMachineParameters,
    getWorkstations,
    getWorkstationStatusses,
    getShifts,
    getProgressions,
    getRestrictions,
    getRestrictionTypes,
    getWorkingHours,
    getLatestNotifications
};

//in backend => order by ScheduledOn
function getProductionOrdersByMachine(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYMACHINE);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrdersBySearchText(searchText) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYSEARCHTEXT);
    url += `?searchText=${searchText}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getOrderDetailsByOrderId(Id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ORDERDETAILS);
    url += `?Id=${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveVisitorRegistration(name, email, job, company) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        }, body: JSON.stringify({
            Name: name,
            Email: email,
            Job: job,
            Company: company
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEVISITORREGISTRATION);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}


function updateProductionOrderMetaData(productionOrder) {
    const requestOptions = {
        method: 'PUT', headers: {
            'Content-Type': 'application/json',
        }, body: JSON.stringify(
            productionOrder
        )
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEPRODUCTIONORDERMETADATA);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function assignQuantityAtMachine(machineId, productId, quantity) {
    
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            machineId: machineId,
            quantityAssigned: parseFloat(quantity),
            metaData: "[{\"MetaDataType\":1, \"Version\": 1,\"MetaData\":[{\"ProductId\": " + productId + "}]}]"           
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ASSIGNQUANTITYATMACHINE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineInAssignedByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINEINASSIGNEDBYMACHINEID);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function deleteMachineInAssignedById(Id) {
    const requestOptions = {
        method: 'DELETE', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEMACHINEINASSIGNEDBYID);
    url += `${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function startProductionOrder(productionOrderId,selectedWorkstation) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
       
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STARTPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;
    url += `&selectedMachineId=${selectedWorkstation}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function pauseProductionOrder(productionOrderId) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
       
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PAUSEPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function stopProductionOrder(productionOrderId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STOPPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function finishProductionOrder(productionOrderId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
      
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_FINISHPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getLatestNotifications() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLATESTNOTIFICATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getActiveTransportOrders() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetActiveTransportOrders', requestOptions).then(handleResponse);
}

function getTransportOrdersHistory() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetTransportOrdersHistory', requestOptions).then(handleResponse);
}

function createNewBooking(newBooking) {
    const requestOptions = {
        method: 'POST', headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: newBooking
    };
    return fetch('/Api/CreateNewBooking', requestOptions).then(handleResponse);
}

function getQualityChecksByOrderId(id) {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityChecksByOrderId?id=' + id, requestOptions).then(handleResponse);
}

function getOperators() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetOperators', requestOptions).then(handleResponse);
}

function getQualityCheckSteps() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityCheckSteps', requestOptions).then(handleResponse);
}

function getMachineParameters() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetMachineParameters', requestOptions).then(handleResponse);
}

function getWorkstations() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkstations', requestOptions).then(handleResponse);
}

function getWorkstationStatusses() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkstationStatusses', requestOptions).then(handleResponse);
}

function getShifts() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetShifts', requestOptions).then(handleResponse);
}

function getProgressions() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetProgressions', requestOptions).then(handleResponse);
}

function getRestrictions() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetRestrictions', requestOptions).then(handleResponse);
}

function getWorkingHours() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkingHours', requestOptions).then(handleResponse);
}

function getRestrictionTypes() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetRestrictionTypes', requestOptions).then(handleResponse);
}



